var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.919,
    height: 47.919,
    viewBox: "0 0 47.919 47.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "request",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M216.76,0H198.716A5.912,5.912,0,0,0,192.8,5.915V32.981a1.4,1.4,0,0,0,2.246,1.123l5.64-4.23H216.76a5.912,5.912,0,0,0,5.915-5.915V5.915A5.912,5.912,0,0,0,216.76,0Zm-9.023,23.108a1.4,1.4,0,1,1,1.4-1.4A1.4,1.4,0,0,1,207.738,23.107Zm1.4-6.209v.294a1.4,1.4,0,1,1-2.808,0v-1.5a1.4,1.4,0,0,1,1.4-1.4,2.355,2.355,0,1,0-2.355-2.357,1.4,1.4,0,1,1-2.808,0v0a5.163,5.163,0,1,1,6.567,4.971Zm0,0",
    transform: "translate(-174.756)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M37.7,247.624a6.636,6.636,0,1,1-6.636-6.637A6.636,6.636,0,0,1,37.7,247.624Zm0,0",
    transform: "translate(-22.139 -218.434)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M8.922,382.8A8.923,8.923,0,0,0,0,391.727v1.765a1.4,1.4,0,0,0,1.4,1.4H16.441a1.4,1.4,0,0,0,1.4-1.4v-1.765A8.923,8.923,0,0,0,8.922,382.8Zm0,0",
    transform: "translate(0 -346.978)",
    fill: "#1a8fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.2f90243a87da1e134555d20d6e13730f.svg";
export { ForwardRef as ReactComponent };